import * as ReactDOM from "react-dom";
import * as toastr from "toastr";
import { renderReactComponent } from "~/sharedComponents/errorBoundary/renderReact";
import * as styles from "./toastr.less";

const defaultOptions: ToastrOptions = {
    closeButton: true,
    positionClass: styles.bottom_left,
    titleClass: styles.title,
    messageClass: styles.message,
    timeOut: 3500,
    newestOnTop: false,
    closeHtml: "<span></span>",
    tapToDismiss: false,
    escapeHtml: true,
};

const mergeOptions = (options: ToastrOptions, additionalOptions?: ToastrOptions) => {
    return { ...defaultOptions, ...options, ...additionalOptions };
};

export function showActionFeedback(message: string, title: string = null, options: ToastrOptions = {}) {
    return toastr.success(message, title, mergeOptions(options));
}

export function showErrorFeedback(message: string, title: string = null, options: ToastrOptions = {}) {
    return toastr.error(message, title, mergeOptions(options, { timeOut: 0 }));
}

export function showWarningFeedback(message: string, title: string = null, options: ToastrOptions = {}) {
    return toastr.warning(message, title, mergeOptions(options, { timeOut: 0 }));
}

export function clearFeedback(element?: any) {
    return toastr.clear(element);
}

export function removeFeedback() {
    return toastr.remove();
}

const showReactFeedback =
    (action: typeof showActionFeedback | typeof showErrorFeedback | typeof showWarningFeedback) =>
    (content: any, title: string = null, options: ToastrOptions = {}) => {
        const reactContentWrapper = document.createElement("div");
        reactContentWrapper.className = styles.message_container;
        renderReactComponent(content, reactContentWrapper);

        const onHidden = () => {
            ReactDOM.unmountComponentAtNode(reactContentWrapper);
        };

        return action(
            reactContentWrapper as undefined as string,
            title,
            mergeOptions(options, { onHidden, escapeHtml: false })
        );
    };

export const showReactActionFeedback = showReactFeedback(showActionFeedback);
export const showReactErrorFeedback = showReactFeedback(showErrorFeedback);
export const showReactWarningFeedback = showReactFeedback(showWarningFeedback);
